/*  @flow */
import * as React from 'react';
import { activities } from 'components/Activity/ActivityData';
import { createRequestExtendContract, updateExtendContract } from 'permissions/contract';
import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

const actionsListData: any = [
  {
    label: 'general:actions.extend_contract',
    icon: '#icon-extend-contract',
    class: '',
    tag: activities.extendContract.tag,
    action: activities.extendContract.action,
    permissions: [...createRequestExtendContract, ...updateExtendContract],
    condition(data: Object, action: Object, callback: Function): React.Node {
      data.disabled = data.assets_count < 1 || !data.end_date;
      return <ActionButton data={data} action={action} onActionDrawer={callback} />;
    },
  },
];

export default actionsListData;
